export const LEGAL_CONTENT = {
  "mentions-legales": {
    title: "Mentions Legales",
    content: `## Mentions légales — IziCatalog

Conformément aux dispositions de la **Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l’Économie Numérique (LCEN)**, il est précisé aux utilisateurs du site **IziCatalog** l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi.

---

## ## 1. Éditeur du site

- **Nom du site / Plateforme** : IziCatalog  
- **URL** : https://catalogio.app  
- **Éditeur** : **SARL DEAL RUN (DEAL RUN)**  
- **Forme juridique** : Société à responsabilité limitée (SARL)  
- **SIRET** : 89535078300018  
- **N° TVA intracommunautaire** : FR44895350783  
- **Siège social** : DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE 33 BOULEVARD DU MAHATMA GANDHI 97490 SAINT-DENIS  
- **Téléphone** : +262693463628  
- **Email** : contact@dealrun.re  
- **Activité** : Édition et exploitation de la plateforme SaaS **IziCatalog**, permettant aux commerçants de créer un catalogue digital, de disposer d’une page publique mobile et de générer des QR codes.

---

## ## 2. Directeur de la publication

- **Directeur de la publication** : **SARL DEAL RUN (DEAL RUN)**  
- **Contact** : contact@dealrun.re  

---

## ## 3. Hébergement

- **Hébergeur** : Emergent Labs  

*(Les coordonnées complètes de l’hébergeur peuvent être communiquées sur demande à l’adresse : contact@dealrun.re.)*

---

## ## 4. Accès au site et à la plateforme

L’accès au site et/ou à la plateforme **IziCatalog** est possible 24h/24 et 7j/7, sauf cas de force majeure, événement hors du contrôle de l’éditeur, pannes éventuelles, interventions de maintenance et mises à jour nécessaires au bon fonctionnement du service.

L’éditeur ne saurait être tenu responsable de toute interruption, suspension ou dysfonctionnement, quelles qu’en soient la cause, la nature ou la durée, pouvant affecter l’accès au site ou à la plateforme, dans les limites prévues par la réglementation applicable.

---

## ## 5. Description du service

IziCatalog est une plateforme SaaS permettant notamment :

- la création et la gestion de catalogues digitaux par des commerçants ;
- la génération de pages publiques accessibles sur mobile ;
- la création et l’utilisation de QR codes donnant accès aux contenus publiés.

Les modalités d’utilisation du service, le cas échéant les conditions tarifaires, et les règles applicables sont précisées dans les documents contractuels et politiques associées (notamment conditions générales, politique de confidentialité, politique cookies, etc.) lorsqu’ils sont publiés et applicables.

---

## ## 6. Propriété intellectuelle

L’ensemble des éléments accessibles sur le site et la plateforme IziCatalog, notamment (sans que cette liste soit limitative) : textes, graphismes, logos, icônes, images, vidéos, interfaces, architecture, bases de données, code source et code objet, ainsi que la dénomination **IziCatalog**, sont susceptibles d’être protégés par le **droit de la propriété intellectuelle**.

Sauf indication contraire, ces éléments sont la propriété exclusive de **SARL DEAL RUN** et/ou font l’objet de droits d’usage concédés à son profit.

### ### 6.1. Interdictions
Toute reproduction, représentation, modification, adaptation, extraction, réutilisation, distribution, rediffusion, publication, transmission, décompilation ou exploitation, totale ou partielle, du site et/ou de l’un quelconque de ses éléments, par quelque procédé que ce soit, sans autorisation écrite préalable de l’éditeur, est interdite et est susceptible de constituer une contrefaçon.

### ### 6.2. Contenus publiés par les utilisateurs (commerçants)
Les commerçants/utilisateurs demeurent en principe responsables des contenus qu’ils publient via IziCatalog (ex. descriptions, prix, images, mentions légales propres, informations produits). Ils garantissent détenir les droits nécessaires (notamment droits d’auteur, droits sur les marques, droits à l’image) et s’engagent à respecter la réglementation applicable (notamment en matière de consommation, publicité, prix, données personnelles).

L’éditeur se réserve la possibilité de retirer, suspendre l’accès ou demander la modification de contenus manifestement illicites ou signalés comme tels, dans les conditions prévues par la loi et, le cas échéant, par les conditions contractuelles applicables.

---

## ## 7. Responsabilité

L’éditeur s’efforce de fournir sur le site et la plateforme des informations aussi précises que possible. Toutefois, l’éditeur ne garantit pas l’exactitude, l’exhaustivité et la mise à jour des informations diffusées, ni l’absence d’erreurs.

L’utilisateur reconnaît utiliser le site et/ou la plateforme sous sa responsabilité exclusive. L’éditeur ne saurait être tenu responsable :

- des dommages directs ou indirects résultant de l’utilisation du site, de la plateforme ou de l’impossibilité d’y accéder ;
- des dommages résultant d’une intrusion frauduleuse ou d’une attaque informatique ;
- des dommages résultant de l’usage des contenus publiés par des tiers/utilisateurs sur les pages publiques générées.

---

## ## 8. Liens hypertextes

Le site peut contenir des liens hypertextes vers des sites tiers. L’éditeur n’exerce aucun contrôle sur ces sites et ne saurait être tenu responsable de leur contenu, de leur disponibilité, ni des pratiques de ces tiers (notamment en matière de données personnelles).

La création de liens hypertextes vers le site IziCatalog est en principe autorisée sous réserve :

- qu’elle ne porte pas atteinte aux intérêts et à l’image de l’éditeur ;
- qu’elle ne crée pas de confusion quant à la source des services et contenus ;
- qu’elle ne soit pas réalisée depuis un site au contenu illicite.

L’éditeur se réserve le droit de demander la suppression d’un lien qu’il estimerait non conforme.

---

## ## 9. Données personnelles

L’utilisation du site et/ou de la plateforme peut impliquer des traitements de données à caractère personnel. Les modalités de collecte, d’utilisation, de conservation, de sécurité, ainsi que les droits des personnes concernées sont décrits dans la **Politique de confidentialité** de IziCatalog, lorsqu’elle est publiée et applicable.

Pour toute demande relative aux données personnelles, vous pouvez contacter : **contact@dealrun.re**.

---

## ## 10. Cookies et traceurs

Le site et/ou la plateforme peuvent utiliser des cookies et autres traceurs (par exemple, cookies nécessaires au fonctionnement, mesure d’audience, etc.). Les modalités de dépôt et de gestion des cookies sont précisées dans la **Politique cookies** (ou module de gestion du consentement) lorsqu’elle est publiée et applicable.

---

## ## 11. Droit applicable et juridiction compétente

Les présentes mentions légales sont soumises au **droit français**.

En cas de litige et à défaut de résolution amiable, les tribunaux compétents seront déterminés conformément aux règles de procédure applicables (notamment selon la qualité de professionnel ou de consommateur de l’utilisateur, le cas échéant).

---

## ## 12. Contact

Pour toute question relative au site, à la plateforme ou aux présentes mentions légales :

- **Email** : contact@dealrun.re  
- **Téléphone** : +262693463628  
- **Adresse** : DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE 33 BOULEVARD DU MAHATMA GANDHI 97490 SAINT-DENIS  

--- 

*Dernière mise à jour : 16/02/2026*`
  },
  "politique-confidentialite": {
    title: "Politique de Confidentialite",
    content: `# Politique de Confidentialité — IziCatalog

**Dernière mise à jour : 16/02/2026**

La présente Politique de Confidentialité décrit la manière dont **IziCatalog** (ci-après la « Plateforme ») collecte, utilise et protège vos données à caractère personnel, ainsi que les droits dont vous disposez conformément au **Règlement (UE) 2016/679 (RGPD)** et à la **Loi Informatique et Libertés** modifiée.

---

## 1. Identité du responsable de traitement

Le responsable de traitement est :

- **Raison sociale :** SARL **DEAL RUN** (DEAL RUN)  
- **SIRET :** 89535078300018  
- **N° TVA intracommunautaire :** FR44895350783  
- **Siège social :** DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE, 33 BOULEVARD DU MAHATMA GANDHI, 97490 SAINT-DENIS  
- **Email :** contact@dealrun.re  
- **Téléphone :** +262693463628  
- **Site / Plateforme :** **IziCatalog** — https://catalogio.app  

---

## 2. Définitions (rappels)

- **Données personnelles :** toute information se rapportant à une personne physique identifiée ou identifiable.  
- **Traitement :** toute opération (collecte, stockage, consultation, suppression, etc.).  
- **Responsable de traitement :** entité qui détermine les finalités et moyens du traitement.  
- **Sous-traitant :** entité traitant des données pour le compte du responsable.

---

## 3. Données collectées

Selon votre usage de IziCatalog, nous pouvons collecter les catégories de données suivantes :

### 3.1. Données d’identification et de compte
- Nom, prénom (le cas échéant)
- Adresse email
- Numéro de téléphone (le cas échéant)
- Identifiants de connexion (et informations techniques liées à l’authentification)

### 3.2. Données liées au compte professionnel (commerçants)
- Nom de l’enseigne / entreprise
- Informations publiques du commerce (adresse, horaires, description, liens, etc.) si renseignées
- Contenus du catalogue (produits, photos, prix, descriptions) saisis/importés par le commerçant

> **Important :** certains contenus publiés (ex. page publique mobile) peuvent être **accessibles au public** selon vos paramètres de publication.

### 3.3. Données de navigation et techniques
- Adresse IP (pouvant être considérée comme donnée personnelle)
- Logs, date/heure d’accès, type de navigateur, système d’exploitation, identifiants d’appareil
- Données d’usage (pages consultées, actions, erreurs)

### 3.4. Données relatives aux QR codes et pages publiques
- Informations liées à la génération et à l’utilisation des QR codes (ex. URL associée, métriques de consultation)
- Statistiques de consultation des pages publiques (ex. nombre de vues, informations techniques)

### 3.5. Données de support et de communication
- Messages envoyés via nos canaux de contact (email)
- Informations nécessaires au traitement de votre demande

### 3.6. Paiement
Si des fonctionnalités payantes existent, les données de paiement sont généralement traitées par un prestataire de paiement. IziCatalog ne conserve pas les données de carte bancaire (sauf indication contraire explicitée au moment du paiement).  
*(Le cas échéant, les informations exactes dépendront du prestataire de paiement utilisé.)*

---

## 4. Finalités et bases légales des traitements

Nous traitons vos données uniquement lorsque cela est nécessaire et sur une base légale conforme.

| Finalité | Exemples de traitements | Base légale |
|---|---|---|
| Création et gestion du compte | inscription, authentification, gestion du profil | **Exécution d’un contrat** (CGU/abonnement) |
| Fourniture du service IziCatalog | création de catalogues, pages publiques, génération de QR codes | **Exécution d’un contrat** |
| Statistiques et amélioration du service | mesure d’audience, performance, correction de bugs | **Intérêt légitime** (amélioration et sécurité) / **Consentement** si cookies non essentiels |
| Support client et communications opérationnelles | réponse aux demandes, messages de service | **Exécution d’un contrat** / **Intérêt légitime** |
| Sécurité, prévention fraude et abus | logs, détection d’activités suspectes | **Intérêt légitime** / obligation légale selon cas |
| Obligations légales et comptables | facturation, obligations de conservation | **Obligation légale** |
| Prospection (si applicable) | newsletters, offres | **Consentement** ou **intérêt légitime** (B2B, sous réserve du droit d’opposition) |

---

## 5. Cookies et traceurs

### 5.1. Qu’est-ce qu’un cookie ?
Un cookie est un petit fichier déposé sur votre terminal (ordinateur, mobile) lors de la consultation d’un site/service. Il permet notamment de mémoriser des préférences ou de mesurer l’audience.

### 5.2. Types de cookies susceptibles d’être utilisés
- **Cookies strictement nécessaires** : indispensables au fonctionnement (ex. session, sécurité, authentification).  
  - **Base légale :** intérêt légitime / nécessité technique (pas de consentement requis).
- **Cookies de mesure d’audience / performance** : statistiques, amélioration de l’expérience.  
  - **Base légale :** **consentement** lorsque requis par la réglementation (selon la nature du cookie et son paramétrage).
- **Cookies de personnalisation** (le cas échéant) : mémorisation de préférences.  
  - **Base légale :** intérêt légitime ou consentement selon le contexte.
- **Cookies marketing** (le cas échéant) : ciblage publicitaire.  
  - **Base légale :** **consentement**.

### 5.3. Gestion du consentement
Lorsque la réglementation l’exige, un bandeau de consentement permet :
- d’accepter/refuser tout ou partie des cookies non essentiels ;
- de modifier vos choix à tout moment.

### 5.4. Paramétrage via le navigateur
Vous pouvez également supprimer ou bloquer les cookies via les paramètres de votre navigateur. Le blocage des cookies strictement nécessaires peut dégrader le fonctionnement de IziCatalog.

---

## 6. Destinataires des données

Vos données peuvent être accessibles :

- **Au sein de SARL DEAL RUN**, aux personnes habilitées (support, technique, administratif), dans la limite du besoin d’en connaître.
- **À nos sous-traitants**, lorsque nécessaire (hébergement, maintenance, emailing, analytics, paiement, support), agissant sur instructions documentées.
- **Aux autorités compétentes**, lorsque la loi l’exige (réquisition, obligation légale).

### Hébergement
- **Hébergeur :** **Emergent Labs** (sous-traitant d’hébergement)

> Nous veillons à encadrer nos relations avec les sous-traitants par des clauses conformes à l’article 28 du RGPD.

---

## 7. Transferts hors Union européenne

Dans la mesure du possible, nous privilégions des prestataires et un stockage au sein de l’EEE.  
Si un transfert de données hors EEE devait avoir lieu (ex. certains outils tiers), il serait encadré par des garanties appropriées (ex. **Clauses Contractuelles Types** de la Commission européenne) et, si nécessaire, des mesures supplémentaires.

---

## 8. Durées de conservation

Nous conservons vos données uniquement le temps nécessaire aux finalités décrites, puis nous les supprimons ou les anonymisons, sauf obligation légale contraire.

### 8.1. Conservation indicative (principes)
- **Données de compte (utilisateur/commerçant)** : pendant la durée de la relation contractuelle, puis archivage limité pour gérer les obligations légales et la preuve.  
- **Données de catalogue et contenus** : tant que le compte est actif et/ou tant que vous les publiez ; suppression ou anonymisation après clôture du compte selon les paramètres et obligations.  
- **Logs techniques et sécurité** : durée limitée et proportionnée (sécurité, détection d’incidents).  
- **Support** : le temps nécessaire au traitement de la demande, puis archivage probatoire si nécessaire.  
- **Facturation / données comptables** : conservation conforme aux obligations légales applicables.

> Les durées exactes peuvent varier selon votre statut (client, prospect), les obligations applicables et la configuration du service. Vous pouvez demander des précisions via les coordonnées de contact ci-dessous.

---

## 9. Sécurité des données

Nous mettons en œuvre des mesures techniques et organisationnelles appropriées, adaptées aux risques, notamment :
- contrôle des accès (habilitations),
- sécurisation des environnements et des communications,
- sauvegardes,
- journalisation et surveillance,
- mesures de protection contre la perte, l’altération, l’accès non autorisé.

Aucune méthode de transmission ou de stockage n’étant totalement sûre, nous ne pouvons garantir une sécurité absolue, mais nous appliquons les standards raisonnables du secteur.

---

## 10. Vos droits (RGPD)

Conformément au RGPD, vous disposez des droits suivants :

- **Droit d’accès** : obtenir confirmation et copie de vos données.
- **Droit de rectification** : corriger des données inexactes/incomplètes.
- **Droit à l’effacement** (« droit à l’oubli ») : dans les conditions prévues par le RGPD.
- **Droit à la limitation** : geler temporairement certains traitements.
- **Droit d’opposition** : vous opposer à certains traitements fondés sur l’intérêt légitime, et à la prospection.
- **Droit à la portabilité** : recevoir vos données dans un format structuré (pour les traitements fondés sur le contrat ou le consentement et réalisés par moyens automatisés).
- **Droit de retirer votre consentement** : à tout moment, pour les traitements fondés sur le consentement (sans affecter la licéité antérieure).
- **Droit de définir des directives post-mortem** (droit français) sur le sort de vos données.

### Exercice des droits
Pour exercer vos droits, contactez-nous (voir section 12).  
Nous pouvons demander une preuve d’identité en cas de doute raisonnable afin de sécuriser la demande.

**Délai de réponse :** en principe **1 mois**, prolongeable selon la complexité.

### Réclamation auprès de l’autorité de contrôle
Vous pouvez déposer une réclamation auprès de la **CNIL** : https://www.cnil.fr

---

## 11. Données des mineurs

IziCatalog est destiné principalement à un usage professionnel (commerçants). Nous ne visons pas la collecte de données auprès de mineurs. Si vous estimez qu’un mineur nous a communiqué des données, contactez-nous afin de procéder à leur suppression dans les meilleurs délais.

---

## 12. Contact / DPO (Délégué à la protection des données)

DEAL RUN n’a pas nécessairement l’obligation de désigner un DPO. À défaut de DPO désigné, un **référent confidentialité** traite vos demandes.

- **Contact confidentialité / DPO (si désigné) :** contact@dealrun.re  
- **Adresse :** DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE, 33 BOULEVARD DU MAHATMA GANDHI, 97490 SAINT-DENIS  
- **Téléphone :** +262693463628  

Indiquez en objet : **« Confidentialité — IziCatalog »**.

---

## 13. Mise à jour de la Politique

Nous pouvons modifier la présente Politique pour refléter des évolutions légales, techniques ou fonctionnelles. La version applicable est celle publiée sur https://catalogio.app à la date de consultation. En cas de modification substantielle, nous pourrons vous en informer par des moyens appropriés (ex. email ou notification dans la Plateforme).

---

## 14. Annexes (recommandées — optionnelles)

Pour une conformité optimale et une information complète, les documents/éléments suivants peuvent être fournis sur demande ou via la Plateforme :
- liste des sous-traitants (hébergement, analytics, emailing, support, paiement) et leur localisation ;
- tableau détaillé des cookies (nom, finalité, durée, éditeur) ;
- durées de conservation précises par catégorie (politique d’archivage).

--- 

Si vous me confirmez si IziCatalog utilise (i) un outil d’analytics, (ii) un prestataire de paiement, (iii) un outil d’emailing/CRM et si des pages publiques sont indexables par les moteurs de recherche, je peux adapter la politique avec une **liste de sous-traitants** et un **tableau de cookies** parfaitement alignés sur votre configuration.`
  },
  "cgu": {
    title: "Conditions Generales d'Utilisation",
    content: `# Conditions Générales d’Utilisation (CGU) – IziCatalog

**Dernière mise à jour : 16/02/2026**

Les présentes Conditions Générales d’Utilisation (ci-après les « **CGU** ») régissent l’accès et l’utilisation du site et de la plateforme SaaS **IziCatalog** (ci-après la « **Plateforme** »), accessible à l’adresse **https://catalogio.app** (ci-après le « **Site** »).

En accédant au Site et/ou en utilisant la Plateforme, vous reconnaissez avoir pris connaissance des présentes CGU et les accepter sans réserve.

---

## 1. Éditeur – Mentions légales

La Plateforme est éditée par :

- **Raison sociale :** **SARL DEAL RUN** (nom commercial : **DEAL RUN**)  
- **SIRET :** 89535078300018  
- **N° TVA intracommunautaire :** FR44895350783  
- **Siège social :** DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE, 33 BOULEVARD DU MAHATMA GANDHI, 97490 SAINT-DENIS  
- **Email :** contact@dealrun.re  
- **Téléphone :** +262693463628  
- **Activité :** édition et exploitation de la plateforme SaaS **IziCatalog** permettant aux commerçants de créer un catalogue digital, obtenir une page publique mobile et générer des QR codes.

**Hébergeur :** Emergent Labs (ci-après l’« Hébergeur »).

---

## 2. Définitions

- **Utilisateur** : toute personne naviguant sur le Site.  
- **Client** : toute personne physique ou morale disposant d’un Compte et utilisant les Services à des fins professionnelles (commerçants, entreprises, indépendants).  
- **Compte** : espace personnel créé lors de l’inscription.  
- **Services** : fonctionnalités proposées via IziCatalog (création de catalogues digitaux, page publique mobile, génération de QR codes, publication et gestion de contenus, etc.).  
- **Contenus** : informations, textes, images, prix, descriptions, marques, logos, photos produits, et plus généralement tout élément publié par le Client sur la Plateforme.

---

## 3. Objet des CGU

Les CGU ont pour objet de définir :
- les conditions d’accès au Site et à la Plateforme ;
- les modalités d’inscription et d’utilisation des Services ;
- les droits et obligations de l’Éditeur et des Utilisateurs/Clients ;
- les règles relatives à la propriété intellectuelle, la responsabilité, la résiliation et les litiges.

---

## 4. Accès au Site et à la Plateforme

### 4.1. Conditions d’accès
L’accès au Site est en principe libre. L’accès à la Plateforme et à certaines fonctionnalités nécessite la création d’un Compte.

Le Client déclare :
- disposer de la capacité juridique et/ou des pouvoirs nécessaires pour engager la structure qu’il représente ;
- utiliser la Plateforme dans un cadre conforme à la réglementation applicable.

### 4.2. Disponibilité
L’Éditeur met en œuvre des moyens raisonnables pour assurer l’accessibilité et le bon fonctionnement de la Plateforme. Toutefois, l’accès peut être suspendu notamment pour maintenance, mises à jour, contraintes techniques ou en cas de force majeure.

Aucune garantie de disponibilité ininterrompue n’est fournie.

---

## 5. Inscription et gestion du Compte

### 5.1. Création de Compte
Pour accéder aux Services, le Client doit s’inscrire en fournissant des informations exactes, complètes et à jour. Le Client s’engage à mettre à jour ces informations en cas de changement.

### 5.2. Identifiants et sécurité
Les identifiants de connexion sont personnels. Le Client est responsable :
- de la confidentialité de ses identifiants ;
- de toute activité réalisée via son Compte, sauf preuve d’une utilisation frauduleuse non imputable au Client.

En cas de suspicion de compromission, le Client doit contacter l’Éditeur sans délai à **contact@dealrun.re**.

### 5.3. Exactitude des informations et représentation
Le Client garantit qu’il détient l’ensemble des droits et autorisations nécessaires à la publication et à l’exploitation des Contenus (notamment droits d’auteur, droits sur les marques, droit à l’image, droits des tiers).

---

## 6. Description des Services

IziCatalog propose notamment :
- la **création et gestion** d’un catalogue digital (fiches produits, catégories, descriptions, prix, visuels) ;
- l’attribution d’une **page publique mobile** permettant la consultation du catalogue ;
- la **génération de QR codes** pointant vers la page publique et/ou des éléments du catalogue ;
- des fonctionnalités d’édition, de mise à jour et de publication des Contenus.

Les fonctionnalités peuvent évoluer (ajout, suppression, modification) pour des raisons techniques, réglementaires ou d’amélioration du service.

---

## 7. Règles d’usage – Obligations du Client

Le Client s’engage à utiliser la Plateforme :
- conformément aux lois et règlements en vigueur (notamment droit de la consommation si applicable, droit de la publicité, propriété intellectuelle, données personnelles) ;
- conformément aux présentes CGU et, le cas échéant, aux conditions contractuelles associées à un abonnement/plan.

### 7.1. Contenus interdits
Il est interdit de publier, transmettre ou rendre accessible via IziCatalog tout Contenu :
- illicite, diffamatoire, injurieux, haineux, violent, discriminatoire, harcelant ;
- portant atteinte à l’ordre public ou aux bonnes mœurs ;
- contrefaisant (marques, droits d’auteur), ou portant atteinte aux droits des tiers ;
- contenant des données personnelles de tiers sans base légale/consentement adéquat ;
- trompeur (ex. prix mensongers, fausses promotions, informations commerciales fallacieuses).

### 7.2. Interdictions techniques
Le Client s’interdit notamment :
- toute tentative d’intrusion, de contournement de sécurité, d’extraction automatisée non autorisée (scraping), d’attaque (DDoS), ou d’usage abusif ;
- l’introduction de virus, codes malveillants, ou tout élément de nature à perturber la Plateforme.

### 7.3. Obligations commerciales et légales du Client
Le Client demeure seul responsable :
- des informations affichées (prix, disponibilité, caractéristiques, mentions légales, informations précontractuelles le cas échéant) ;
- des règles applicables à son activité (ex. promotions, TVA, affichage des prix, réglementation sectorielle).

IziCatalog est un outil de publication et de diffusion de catalogue, et ne se substitue pas aux obligations légales du Client.

---

## 8. Page publique, QR codes et indexation

La Plateforme peut générer une page publique accessible via URL et/ou QR code. Le Client reconnaît que :
- la page publique est susceptible d’être consultée par tout internaute disposant du lien/QR code ;
- la page publique peut être indexée par des moteurs de recherche, sauf fonctionnalité contraire explicitement proposée par la Plateforme et correctement paramétrée par le Client.

Le Client est responsable des choix de publication et de partage de ses liens/QR codes.

---

## 9. Propriété intellectuelle

### 9.1. Droits de l’Éditeur
Le Site, la Plateforme, leur architecture, interfaces, contenus éditoriaux, logiciels, bases de données, marques, logos, graphismes et plus généralement tous éléments fournis par l’Éditeur sont protégés par le droit de la propriété intellectuelle.

Toute reproduction, représentation, adaptation, modification, extraction ou réutilisation, totale ou partielle, sans autorisation écrite préalable de l’Éditeur est interdite, sauf exceptions légales.

### 9.2. Droits du Client sur ses Contenus
Le Client conserve l’ensemble des droits sur ses Contenus.

En publiant des Contenus sur IziCatalog, le Client concède à l’Éditeur, pour la durée d’utilisation des Services, une licence non exclusive, mondiale et gratuite permettant :
- l’hébergement, la reproduction technique, la mise en forme, l’affichage et la diffusion des Contenus **uniquement** aux fins de fourniture du Service (publication du catalogue, génération de la page publique, affichage via QR code, opérations techniques associées).

Cette licence prend fin à la suppression du Compte et/ou des Contenus, sous réserve des obligations légales de conservation et des sauvegardes techniques (voir ci-dessous).

### 9.3. Sauvegardes et rémanence
Des copies techniques (sauvegardes) peuvent subsister pendant une durée limitée pour des raisons de sécurité et de continuité, sans que cela n’implique une remise à disposition publique.

---

## 10. Données personnelles

L’Éditeur peut être amené à traiter des données personnelles (compte, contact, données de connexion, etc.). Ces traitements sont réalisés conformément au **RGPD** (Règlement UE 2016/679) et à la **loi Informatique et Libertés**.

Les modalités détaillées (finalités, bases légales, durées de conservation, destinataires, droits des personnes) sont décrites dans la politique de confidentialité de IziCatalog, accessible depuis le Site.

Pour toute demande relative aux données personnelles : **contact@dealrun.re**.

---

## 11. Responsabilité

### 11.1. Responsabilité de l’Éditeur (principes)
L’Éditeur fournit la Plateforme « en l’état » et met en œuvre des moyens raisonnables pour en assurer le fonctionnement.

La responsabilité de l’Éditeur ne saurait être engagée en cas :
- d’interruptions ou dysfonctionnements dus au réseau Internet, aux opérateurs, au navigateur, au matériel du Client ;
- d’incidents imputables à l’Hébergeur ou à des prestataires tiers ;
- d’utilisation non conforme des Services par le Client ;
- de perte de données imputable au Client (absence d’export, mauvaise manipulation, divulgation d’identifiants, etc.) ;
- de force majeure au sens de l’article 1218 du Code civil et de la jurisprudence.

### 11.2. Responsabilité relative aux Contenus
Le Client est seul responsable des Contenus qu’il publie et des conséquences de leur diffusion (notamment auprès du public via la page publique).

L’Éditeur n’est pas responsable :
- des erreurs, omissions ou inexactitudes des informations publiées par le Client ;
- des litiges entre le Client et ses propres clients ou partenaires ;
- des dommages résultant de la consultation ou de l’utilisation par des tiers des informations publiées par le Client.

### 11.3. Limitation de responsabilité
Dans la mesure permise par le droit applicable, et sauf faute lourde/dol, la responsabilité de l’Éditeur au titre des dommages directs prouvés est limitée au montant effectivement payé par le Client à l’Éditeur au cours des **12 derniers mois** (ou, si aucun paiement, à un plafond forfaitaire de **100 €**), pour le Service à l’origine du dommage.

Sont exclus les dommages indirects (perte d’exploitation, perte de chiffre d’affaires, perte de clientèle, atteinte à l’image, perte de chance, etc.).

---

## 12. Suspension – Résiliation

### 12.1. Suspension
L’Éditeur se réserve la possibilité de suspendre l’accès au Compte, sans indemnité, en cas :
- de manquement aux présentes CGU ;
- de suspicion d’usage frauduleux ou de risque de sécurité ;
- d’atteinte aux droits de tiers ou d’injonction légale/administrative.

Lorsque cela est possible, l’Éditeur informera le Client et pourra demander la mise en conformité.

### 12.2. Résiliation par le Client
Le Client peut cesser d’utiliser la Plateforme et demander la suppression de son Compte selon les modalités disponibles dans la Plateforme ou en contactant **contact@dealrun.re**.

### 12.3. Résiliation par l’Éditeur
En cas de manquement grave (notamment Contenus illicites, contrefaçon, fraude, attaques techniques), l’Éditeur peut résilier le Compte de plein droit, sans préjudice de dommages-intérêts.

### 12.4. Effets de la résiliation
La résiliation entraîne la désactivation du Compte et la cessation d’accès aux Services. Le Client est invité à effectuer, avant résiliation, toute sauvegarde/export de ses Contenus si cette fonctionnalité est disponible.

Certaines dispositions survivront à la résiliation (notamment propriété intellectuelle, responsabilité, litiges).

---

## 13. Signalement de contenu – Coopération

Pour signaler un Contenu manifestement illicite ou une atteinte à des droits (contrefaçon, marque, droit à l’image), le signalement doit être adressé à **contact@dealrun.re** et contenir, dans la mesure du possible :
- l’URL de la page concernée et la description du Contenu ;
- l’identité et les coordonnées du signalant ;
- tout justificatif utile (titres de propriété intellectuelle, éléments d’identification, captures, etc.).

L’Éditeur pourra demander des informations complémentaires et prendre les mesures appropriées (retrait, suspension, etc.) en fonction de la situation.

---

## 14. Liens hypertextes et services tiers

La Plateforme peut contenir des liens vers des sites/services tiers (par exemple via des redirections, intégrations ou contenus externes). L’Éditeur n’exerce aucun contrôle sur ces services et décline toute responsabilité quant à leur disponibilité, contenu, sécurité ou pratiques.

---

## 15. Modification des CGU

L’Éditeur peut modifier les CGU afin de les adapter aux évolutions légales, techniques ou fonctionnelles. La version applicable est celle en vigueur à la date d’utilisation du Service.

En cas de modification substantielle, l’Éditeur pourra en informer les Clients par tout moyen approprié (notification, email, bannière).

---

## 16. Droit applicable – Litiges

### 16.1. Droit applicable
Les présentes CGU sont soumises au **droit français**.

### 16.2. Règlement amiable
En cas de différend, les Parties s’efforceront de rechercher une solution amiable avant toute action judiciaire. Toute réclamation peut être adressée à : **contact@dealrun.re**.

### 16.3. Juridiction compétente
À défaut d’accord amiable, **les tribunaux compétents du ressort de la Cour d’appel territorialement compétente** seront compétents, sous réserve des règles d’ordre public applicables (notamment en cas de Client non professionnel, si applicable).

---

## 17. Contact

Pour toute question relative au Site, à la Plateforme ou aux présentes CGU :  
**Email :** contact@dealrun.re  
**Téléphone :** +262693463628  
**Adresse :** DEAL RUN, APT 7 RESIDENCE ARKEA SAINTE CLOTILDE, 33 BOULEVARD DU MAHATMA GANDHI, 97490 SAINT-DENIS

---

### Annexe (recommandation)
Ces CGU encadrent l’**utilisation** de la Plateforme. Si IziCatalog est proposé via des **abonnements payants**, il est recommandé d’adopter également des **Conditions Générales de Vente (CGV)** (prix, facturation, durée d’engagement, renouvellement, rétractation si applicable, SLA, etc.) et une **Politique de confidentialité / Cookies** dédiée.`
  }
};
